import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Napadajoca hrana",
  "description": "",
  "published": "2007-01-19T00:00:00.000Z",
  "redirect_from": ["/blog/napadajoca-hrana/swizec/316"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Poglejte si ta fantasticen video `}<a parentName="p" {...{
        "href": "http://www.chilloutzone.de/files/07010804.html"
      }}>{`zajcka, ki napade kaco`}</a>{`. Stvar je preko vseh besed, neverjetno kako odlicen je ta zajcek. Kot Rambo!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      